import type { StyleTransferPresentation } from '@genieartinc/schemas/pools/ai'

/** Role rows for Node controls. Only mounted for a Style Transfer node. */
export function StyleTransferInputs({ view }: { view: StyleTransferPresentation }) {
  return (
    <div className="space-y-3 border-t border-border px-3 py-3">
      <p className="text-sm font-semibold">Inputs</p>
      {view.roles.map((role) => (
        <div key={`${role.role}:${role.handleId ?? role.label}`} className="space-y-1" role="group" aria-label={role.label}>
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm">{role.label}</span>
            <span className="text-xs text-muted-foreground">
              {role.status === 'connected' ? 'Connected' : role.status === 'loading' ? 'Loading' : role.status === 'error' ? 'Error' : 'Not connected'}
            </span>
          </div>
          {role.url ? (
            <img src={role.url} alt={role.label} className="max-h-24 w-full rounded bg-muted object-contain" />
          ) : (
            <p className="text-xs text-muted-foreground">{role.message}</p>
          )}
        </div>
      ))}
      {view.precedence && <p className="text-xs text-muted-foreground">{view.precedence}</p>}
      {view.limitation && <p className="text-xs text-muted-foreground">{view.limitation}</p>}
    </div>
  )
}
